module.exports = __webpack_public_path__ + "static/media/Booklet-GlucoseTesting.b29e00a0.pdf";